import { BarChart } from "@mui/icons-material";
import { useSessionContext } from "@/contexts/SessionContext";
import { IFeatures } from "@/utils/interfaces";
import { AdminInsightsPage } from "./AdminInsightsPage";
import { useViewContext } from "@/contexts/ViewContext";

export function useAdminInsightsPage() {
  const { access } = useSessionContext();
  const { availableRoles } = useViewContext();

  const configs: IFeatures = {
    active:
      access?.type === "professional" &&
      (availableRoles?.includes("manager") ||
        availableRoles?.includes("owner")),
    path: "/stats",
    icon: BarChart,
    text: "Insights administrativos",
    subitem: true,
    parent: "Insights",
    sideMenu: true,
    sideMenuIndex: 1,
    avatarMenu: true,
    avatarIndex: 2,
    component: () => <AdminInsightsPage />,
  };

  return configs;
}
